// 组合列处理
import { readonly } from 'vue';
import { ColDef } from 'ag-grid-community';
import { isArray, isString } from 'lodash-es';
import { useShareData } from '../../core/SharedData';
import { getLayout } from '../../core/LayoutPersistent';
import AgHeaderComponent from './AgHeaderComponent.vue';

export function useComplexColumns(
  scope: string,
  tableName: string,
  realColDefs: ColDef<any>[],
  headerSetting: boolean // 是否处理表头设置
) {
  if (!scope || !tableName) return;

  // 处理组合列
  const complexLabelsContainer = useShareData('table', 'complexLabels');
  const complexVisiblesContainer = useShareData('table', 'complexVisibles');

  for (const colDef of realColDefs) {
    if ((colDef as any).complexDef) {
      // 列定义
      const complexDef = (colDef as any).complexDef as Record<
        string,
        string | { label: string; show: boolean }
      >;
      Reflect.deleteProperty(colDef, 'complexDef');

      const complexLabels: Record<string, string> = {};
      const complexVisibles: Record<string, boolean> = {};
      const temComplexVisibles: Record<string, boolean> = {};

      for (const [key, item] of Object.entries(complexDef)) {
        complexLabels[key] = isString(item) ? item : item.label;
        // complexVisibles[key] = isString(item) ? true : item.show;
        temComplexVisibles[key] = isString(item) ? true : item.show;
      }

      const field = colDef.field!;
      // 从配置中加载
      const persistColumns = getLayout<{ id: string; show: boolean }[]>(
        scope,
        ['complex', tableName, field],
        [],
        (v) => !!v.push
      );
      // 应用配置
      persistColumns.forEach((e) => {
        if (Object.hasOwn(temComplexVisibles, e.id)) {
          complexVisibles[e.id] = e.show;
        }
      });
      // 先放入本地缓存数据 以保证顺序同本地缓存一致
      Object.keys(temComplexVisibles).forEach((key) => {
        if (!Object.hasOwn(complexVisibles, key)) {
          complexVisibles[key] = temComplexVisibles[key];
        }
      });

      // 加上tableName防止多个表格(有DataTable情况)冲突
      const name = `${tableName}~${field}`;
      // 向SearchPanel注册列定义, 用于更配置
      complexLabelsContainer.$(name)(complexLabels);

      // 初始化visible列
      complexVisiblesContainer.$(name)(complexVisibles);

      colDef.cellRendererParams = {
        // complex
        complex(
          map: Record<string, JSX.Element | JSX.Element[]>
        ): JSX.Element[] {
          const elements: JSX.Element[] = [];
          for (const name in complexVisibles) {
            // 不可见不显示
            if (!complexVisibles[name]) continue;

            const el = map[name];
            if (!el) continue;

            if (isArray(el)) {
              el.forEach((e) => elements.push(e));
            } else {
              elements.push(el);
            }
          }
          return elements;
        },

        // complexVisibles
        complexVisibles() {
          return readonly(complexVisibles);
        }
      };

      if (headerSetting) {
        // 表头处理
        if (!colDef.headerComponent) {
          colDef.headerComponent = AgHeaderComponent;
        }

        if (colDef.headerComponent == AgHeaderComponent) {
          // 补充header组件参数
          const headerComponentParams =
            colDef.headerComponentParams || (colDef.headerComponentParams = {});

          headerComponentParams.complex = {
            tableName: [scope, tableName],
            labels: complexLabels,
            visibles: () => complexVisibles
          };
        }
      }
    }
  }
}
